<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Select Template'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

    @if (loaded) {
      <tidy-search-input
        [formControl]="searchControl"
        [placeholder]="'Search templates'"
        [icon]="'assets/img/search-header.svg'"
        class="header-search full-width" />

      @if (filteredTemplates.length === 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No templates found matching your search.'" />
          </tidy-row>
        </tidy-alert>
      }

      @for (template of filteredTemplates; track template.id) {
        <tidy-card
          class="template-card"
          [class.disabled]="isCreating"
          (click)="!isCreating && selectTemplate(template)">
          <tidy-card-button>
            <ion-row>
              <tidy-row class="vertical-align-center template-icon-wrapper">
                <tidy-image [src]="'assets/svg/document-text-outline.svg'" class="template-icon" />
              </tidy-row>
              <ion-col>
                <tidy-row>
                  <tidy-text [header]="template.name" />
                </tidy-row>
                <tidy-row>
                  <tidy-text [body]="template.description" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-card-button>
        </tidy-card>
      }
    }

    @if (isCreating) {
      <div class="loading-overlay">
        <div class="loading-overlay-content">
          <ion-spinner name="crescent" class="loading-spinner" />
          <tidy-text [header]="'Creating checklist...'" class="loading-text" />
        </div>
      </div>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
